// Flex, so the trigger is exactly the avatar's box, not a taller line box
// (AvatarGroup's seam is cut from the item's box).
.trigger {
    display: inline-flex;
}
